import * as React from 'react';
import { SVGProps, Ref } from 'react';
const Plus = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeWidth={1.5} d="M9 18V0M0 9h18" />
  </svg>
);
const ForwardRef = React.forwardRef(Plus);
export { ForwardRef as Plus };
